// extracted by mini-css-extract-plugin
export default {"other_news":"styles_other_news__6mcIG","news_item":"styles_news_item__4yaJQ"};